import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import Home from "./pages/Home/Home";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Articles from "./pages/Articles";
import Bookshelf from "./pages/Bookshelf/Bookshelf";
import { Reports } from "./pages/Reports";

const root = ReactDOM.createRoot(document.getElementById("root"));
const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "articles/*",
    element: <Articles />,
  },
  {
    path: "/bookshelf",
    element: <Bookshelf />,
  },
  {
    path: "/reports/*",
    element: <Reports />,
  },
]);

root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);
